import { Box } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import { useIntl } from "react-intl";

interface RecaptchaProps {
  recaptcha: string | null;
  submitCount: number;
  handleRecaptcha: (token: string | null) => void;
}

function Recaptcha({
  recaptcha,
  submitCount,
  handleRecaptcha,
}: RecaptchaProps) {
  const intl = useIntl();

  return (
    <Box bgcolor={"white"} marginTop={"0.5rem"} padding={"1rem"}>
      <ReCAPTCHA
        sitekey="6Lf_H44qAAAAACUt5bXwXPnIPyGY-llndKqBo07R"
        onChange={handleRecaptcha}
      />

      {submitCount > 0 && !recaptcha && (
        <span className="field-error">
          {intl.formatMessage({ id: "VerifyNotRobot" })}
        </span>
      )}
    </Box>
  );
}

export default Recaptcha;
